<article class="formEditor">
    <span class="formLabel">{{ labelText() }}</span>
    @if (multiple()) {
        <lib-generic-type-ahead-multiselect
            [source]="items()"
            [selectedItems]="selectedItems()"
            (selectedItemsChange)="onSelectedItemsChange($event)"
            [config]="{
                defaultText: placeholderText(),
                multiple: multiple(),
                itemDisplayKey: 'name',
                itemTemplate: companyTemplate
            }"
            [placeholder]="placeholderText()"
            (textChange)="onEntityTextChange($event)"
            [isReadOnly]="isReadOnly()"
            id="companies"
        >
        </lib-generic-type-ahead-multiselect>
    } @else {
        <lib-generic-type-ahead-dropdown
            [source]="items()"
            [selectedItem]="selectedItem()"
            (selectedItemChange)="onSelectedItemChange($event)"
            [config]="{
                defaultText: placeholderText(),
                itemDisplayKey: 'name',
                itemTemplate: companyTemplate,
                isActive: selectedItem()?.isActive ?? true
            }"
            [placeholder]="placeholderText()"
            (textChange)="onEntityTextChange($event)"
            [isReadOnly]="isReadOnly()"
            id="companies"
        >
        </lib-generic-type-ahead-dropdown>
    }
</article>

<ng-template #companyTemplate let-data>
    <app-custom-menu-item
        [inputText]="data.inputText"
        [title]="$safeNavigationMigration(data.object?.name)"
        [subtitle]="data.object?.abbreviation ?? ''"
    >
    </app-custom-menu-item>
</ng-template>
